<template>
  <el-table
    class="folder-table"
    :data="tableData"
    style="width: 100%"
    size="medium"
  >
    <el-table-column
      prop="fileName"
      :label="$l('table_label_fileName') || '名称'"
      min-width="260"
    >
      <template slot-scope="{ row }">
        <div class="d-flex align-items-center">
          <span v-if="!row.custDocCode" class="folder-icon" />
          <el-link
            v-if="!row.custDocCode"
            :underline="false"
            @click="$emit('openFolder', row)"
          >
            {{ row.custFolderName }}
          </el-link>
          <span v-else>{{ row.custFileName }}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="fileSize"
      :label="$l('table_label_fileSize') || '大小'"
      min-width="90"
    >
      <template slot-scope="{ row }">
        <span>{{ row.custFileSize || '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="custFileDesc"
      :label="$l('table_label_fileRemark') || '说明'"
      min-width="230"
    >
      <template slot-scope="{ row }">
        <span>{{ row.custFileDesc || '' }}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="custFileStatus"
      :label="$l('table_label_custFileStatus') || '状态'"
      width="90"
    >
      <template slot-scope="{ row }">
        <el-tag
          v-if="row.v_custFileStatus"
          size="mini"
          :type="row.custFileStatus === 'Y' ? 'success' : 'danger'"
        >
          {{ row.v_custFileStatus }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      prop="changeStatusDesc"
      :label="$l('table_label_changeStatusDesc') || '状态说明'"
      min-width="225"
    >
      <template slot-scope="{ row }">
        <span v-if="!row.custDocCode">{{ row.custFolderDesc || '-' }}</span>
        <span v-else>{{ row.changeStatusDesc || '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column
      :label="$l('table_label_modifyData') || '更新时间'"
      min-width="170"
    >
      <template slot-scope="{ row }">
        <div v-if="!row.custDocCode">
          <span>{{ row.modifyByName }}</span>
          <br />
          <span>{{ row.modifyDate }}</span>
        </div>
        <div v-else>
          <span>{{ row.uploadName }}</span>
          <br />
          <span>{{ row.uploadTime }}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column width="80" fixed="right">
      <template slot-scope="{ row }">
        <div style="text-align: center" v-if="row.custDocCode">
          <el-dropdown trigger="click" @command="optDocCommand" size="small">
            <span class="el-dropdown-link">
              <i class="el-icon-more el-icon--right  tool-btn" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in docTableOpts"
                v-show="opt.show == undefined ? true : opt.show(row)"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div style="text-align: center" v-else>
          <el-dropdown trigger="click" @command="optFolderCommand" size="small">
            <span class="el-dropdown-link">
              <i class="el-icon-more el-icon--right  tool-btn" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in folderTableOpts"
                v-show="opt.show == undefined ? true : opt.show(row)"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    docTableOpts() {
      const opts = [
        {
          text: this.$l('menu_text_download') || '下载',
          icon: 'el-icon-download',
          menuType: 'download',
        },
        {
          text: this.$l('menu_text_editDesc') || '修改说明',
          icon: 'el-icon-edit',
          menuType: 'edit',
          show: ({ isAllow, custFileStatus }) => {
            return !this.disabled && isAllow && custFileStatus == 'Y'
          },
        },
        {
          text: this.$l('menu_text_move') || '移动目录',
          icon: 'el-icon-rank',
          menuType: 'move',
          show: ({ isAllow }) => {
            return !this.disabled && isAllow
          },
        },
        {
          text: this.$l('menu_text_doc_deactivate') || '文档停用',
          icon: 'el-icon-delete',
          menuType: 'deactivate',
          show: ({ isAllow, custFileStatus }) => {
            return !this.disabled && isAllow && custFileStatus == 'Y'
          },
        },
        {
          text: this.$l('menu_text_doc_enable') || '文档启用',
          icon: 'el-icon-refresh-left',
          menuType: 'enable',
          show: ({ isAllow, custFileStatus }) => {
            return !this.disabled && isAllow && custFileStatus == 'N'
          },
        },
      ]
      return opts
    },
    folderTableOpts() {
      const opts = [
        {
          text: this.$l('menu_text_view') || '打开',
          icon: 'el-icon-folder-opened',
          menuType: 'view',
        },
        {
          text: this.$l('menu_text_rename') || '重命名',
          icon: 'el-icon-edit',
          menuType: 'edit',
          show: ({ isAllow }) => !this.disabled && isAllow,
        },
        {
          text: this.$l('menu_text_move') || '移动目录',
          icon: 'el-icon-rank',
          menuType: 'move',
          show: ({ isAllow }) => !this.disabled && isAllow,
        },
        {
          text: this.$l('menu_text_del') || '删除',
          icon: 'el-icon-delete',
          menuType: 'delete',
          show: ({ isAllow }) => !this.disabled && isAllow,
        },
      ]
      return opts
    },
  },
  methods: {
    optDocCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return
      switch (menuType) {
        case 'download':
          this.downloadDoc(data)
          break
        case 'edit':
          this.$emit('edit-doc', data)
          break
        case 'move':
          this.$emit('move-doc', data)
          break
        case 'deactivate':
          this.$emit('deactivate-doc', data)
          break
        case 'enable':
          this.$emit('enable-doc', data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    downloadDoc({ custFileCode }) {
      this.$api.SYS_FILEDOWNLOAD(custFileCode)
    },
    optFolderCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return
      switch (menuType) {
        case 'view':
          this.$emit('openFolder', data)
          break
        case 'edit':
          this.$emit('edit-folder', data)
          break
        case 'move':
          this.$emit('move-folder', data)
          break
        case 'delete':
          this.delFolder(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async delFolder({ custFolderCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_delFolder') || '是否要删除该文件夹？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerFolderDelApi({ custFolderCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-icon {
  width: 24px;
  height: 24px;
  min-width: 24px;
  background-image: url('../../../folder-icon.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-right: 4px;
}
</style>
